import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ApiBaseResponse, CommonDropdown, PageData } from '../../../models';

@Injectable()
export class ImportResultService {
  private apiUrl: string = environment.apiUrl + '/lotResults';
  private ddUrl: string = environment.apiUrl + '/Auction/AuctionsHaveLotNotHostedBiddingDropdownList';

  constructor(private http: HttpClient) { }

  uploadLotResults(auctionId: number, file: File): Observable<any> {
    let formData = new FormData();
    formData.append('auctionId', '' + auctionId);
    (typeof file === 'string')?
    formData.append('file', file):
    formData.append('file', file,file?.name);
    return this.http.post<ApiBaseResponse<any>>(this.apiUrl + '/importLotResults', formData)
      .pipe(map(it => it.data));
  }

  uploadAuctionUsers(auctionId: number, file: File): Observable<any> {
    let formData = new FormData();
    formData.append('auctionId', '' + auctionId);
    (typeof file === 'string')?
    formData.append('file', file):
    formData.append('file', file,file?.name);
    return this.http.post<ApiBaseResponse<any>>(this.apiUrl + '/importAuctionUsers', formData)
      .pipe(map(it => it.data));
  }

  checkAuctionUsers(auctionId: number): Observable<boolean> {
    return this.http.get<ApiBaseResponse<boolean>>(this.apiUrl + '/importAuctionUsers', {
      params: { 'auctionId': auctionId.toString() }
    })
      .pipe(map(it => it.data));
  }

  getLotResults(pagingModel: PagingModel): Observable<PageData<any>> {
    let param = new HttpParams();

    if (pagingModel.searchTerm)
      param = param.append('searchTerm', pagingModel.searchTerm);
    param = param.append('auctionId', pagingModel.auctionId.toString());
    param = param.append('pageNumber', pagingModel.pageNum.toString());
    param = param.append('pageSize', pagingModel.pageSize.toString());
    param = param.append('isPaginated', '' + true);

    return this.http.get<ApiBaseResponse<any>>(this.apiUrl + '/GetLotResultByAuctionId', {
      params: param
    })
      .pipe(map((it) => ({ data: it.data, totalCount: it.pagingInfo.totalCount })));
  }

  getAuctionsForDD(): Observable<CommonDropdown[]> {
    return this.http.get<ApiBaseResponse<CommonDropdown[]>>(this.ddUrl).pipe(map(it => it.data));
  }
}

export interface PagingModel {
  auctionId: number;
  searchTerm: string;
  pageNum: number;
  pageSize: number;
}
